// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block';
import Swiper, { Navigation, Pagination, A11y, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';

// Styles
import './_hero-banner.scss';

// -------------------------------------
// Hooks
// -------------------------------------

// Scripts for Videos
function heroBannerVideo() {
    const heroBannerVideos = document.querySelectorAll('#hero-banner__video');
    const heroBannerVimeos = document.querySelectorAll('.hero-banner__wrapper .iframe-block');

    for (const heroBannerVideo of heroBannerVideos) {
        var mobileSrc = heroBannerVideo.dataset.mobileSrc;
        var desktopSrc = heroBannerVideo.dataset.src;

        // switching the video source for mobile vs desktop screens
        if (window.innerWidth < 680) {
            if (mobileSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = mobileSrc;

                while (heroBannerVideo.firstChild) {
                    heroBannerVideo.removeChild(heroBannerVideo.firstChild);
                }
                heroBannerVideo.appendChild(source);
                heroBannerVideo.load();
            }
        } else {
            if (desktopSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = desktopSrc;

                while (heroBannerVideo.firstChild) {
                    heroBannerVideo.removeChild(heroBannerVideo.firstChild);
                }
                heroBannerVideo.appendChild(source);
                heroBannerVideo.load();
            }
        }
    }
    
    heroBannerVimeos.forEach((vimeoBlock) => {
        const desktopSource = vimeoBlock.dataset.desktopSource;
        const mobileSource  = vimeoBlock.dataset.mobileSource;
        const vimeoIframe   = vimeoBlock.querySelector('iframe');
        
        if (window.innerWidth < 680 && mobileSource != '') {
            if (vimeoIframe.src != mobileSource) {
                vimeoIframe.src = mobileSource;
            }
        } else {
            if (vimeoIframe.src != desktopSource) {
                vimeoIframe.src = desktopSource;
            }
        }
    });
}

heroBannerVideo();

var cachedWidth = window.innerWidth;
window.addEventListener("resize", function() {
    var newWidth = window.innerWidth;

    // prevent resize function to trigger on mobile when scrolling
    if(newWidth !== cachedWidth){
        //DO RESIZE HERE
        cachedWidth = newWidth;

        // trigger the function only when resize is finished
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(heroBannerVideo, 100);
    }
});


//Scripts for the Swiper slider
$(function() {
    $(".hero-banner__carousel").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("hero-banner-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.find(".swiper-button-prev").addClass("hero-banner-btn-prev-" + index);
        $this.find(".swiper-button-next").addClass("hero-banner-btn-next-" + index);

        var swiper = new Swiper(".hero-banner-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y, Autoplay],
            slidesPerView: 1,
            spaceBetween: 1,
            observer: true,
            showPagination: false,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return '<span>' + current + ' of ' + total + '</span>'; 
                }
            },
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },

            // Navigation arrows
            navigation: {
              nextEl: ".hero-banner-btn-next-" + index,
              prevEl: ".hero-banner-btn-prev-" + index
            }
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');

            if(slideLink) {
                slideLink.addEventListener('focus', function(e) {
                    swiper.slideTo(index);
                })
            }
        });
    });
});